export function Grain({ reducedMotion }: { reducedMotion: boolean }) {
  return (
    <div className={`grain ${reducedMotion ? "is-still" : ""}`} aria-hidden="true">
      <svg className="grain-svg" xmlns="http://www.w3.org/2000/svg">
        <filter id="grain-filter">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.85"
            numOctaves="4"
            stitchTiles="stitch"
          />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#grain-filter)" />
      </svg>
    </div>
  );
}
